import { Directive,ElementRef } from '@angular/core';
declare var jQuery:any;
declare var $ :any;

@Directive({
  selector: '[appSelect]'
})
export class SelectDirective {

  constructor(private el: ElementRef) {

  }
  ngAfterViewInit() {
    (<any>jQuery(this.el.nativeElement)).selectpicker();
  }
}



// WEBPACK FOOTER //
// ./src/app/directive/select.directive.ts